import request from '@/utils/request';

export function queryMoneyRechargePageList(data) {
  return request({
    url: '/money/recharge/queryMoneyRechargePageList',
    method: 'POST',
    data
  });
}
// 删除余额充值
export function removeMoneyRechargeById(data) {
  return request({
    url: '/money/recharge/removeMoneyRechargeById',
    method: 'POST',
    data
  });
}
// 新增余额充值
export function saveMoneyRecharge(data) {
  return request({
    url: '/money/recharge/saveMoneyRecharge',
    method: 'POST',
    data
  });
}
// 修改余额充值
export function updateMoneyRecharge(data) {
  return request({
    url: '/money/recharge/updateMoneyRecharge',
    method: 'POST',
    data
  });
}
// 获取余额充值明细
export function fetchMoneyRechargeDetailById(data) {
  return request({
    url: '/money/recharge/fetchMoneyRechargeDetailById',
    method: 'POST',
    data
  });
}
// 上下架充值金额
export function enableMoneyRecharge(data) {
  return request({
    url: '/money/recharge/enableMoneyRecharge',
    method: 'POST',
    data
  });
}
// 充值记录列表
export function queryUserMoneyRechargeLogPageList(data) {
  return request({
    url: '/user/money/recharge/log/queryUserMoneyRechargeLogPageList',
    method: 'POST',
    data
  });
}
// 新增或修改会员配置信息
export function saveOrUpdateRechargeConfig(data) {
  return request({
    url: '/config/saveOrUpdateRechargeConfig',
    method: 'POST',
    data
  });
}
// 充值配置信息
export function fetchMoneyRechargeConfigDetail(data) {
  return request({
    url: '/config/fetchMoneyRechargeConfigDetail',
    method: 'POST',
    data
  });
}

// 充值记录导出Excel
export function exportUserMoneyRechargePageVoList(data) {
  return request({
    url: '/user/money/recharge/log/exportUserMoneyRechargePageVoList',
    method: 'POST',
    data,
    responseType: 'blob'
  });
}



// WEBPACK FOOTER //
// ./src/api/balance.js